import { jsPDF } from 'jspdf';
import autoTable, { CellDef } from 'jspdf-autotable';
import { ITimeCsv } from '../interfaces/Types';
import TimeUtils from './TimeUtils';

const header = [['Datum', 'KW', 'WT', 'AZ (h)', 'AZ Saldo (h)', 'VZ (min)', 'VZ Saldo (min)', 'Notizen']];

export const exportPdf = (
  data: ITimeCsv[],
  fileName: string,
  month: string,
  name: string,
  formerWorkingTimeBalance: number,
  formerAvailableTimeBalance: number,
  currentWorkingTimeBalance: number,
  currentAvailableTimeBalance: number
) => {
  const doc = new jsPDF();

  // Set the title at the top of the page
  let yPos = 22;
  doc.setFontSize(18);
  doc.text('Monatsbericht', 14, yPos);

  // Add additional information
  yPos += 8;
  doc.setFontSize(10);
  doc.text(`Monat: ${month}`, 14, yPos);
  yPos += 5;
  doc.text(`Name: ${name}`, 14, yPos);

  // Previous month balances
  doc.setFontSize(12);
  yPos += 10;
  doc.text('Vormonat Salden in (h):', 14, yPos);
  let textSize = doc.getTextDimensions('Vormonat Salden in (h):');
  doc.line(14, yPos + 1, 14 + textSize.w, yPos + 1);

  doc.setFontSize(10);
  yPos += 5;
  doc.text(`Arbeitszeit: ${TimeUtils.negativeMinutesToTime(formerWorkingTimeBalance)}`, 14, yPos);
  yPos += 5;
  doc.text(`Verfügungszeit: ${TimeUtils.negativeMinutesToTime(formerAvailableTimeBalance)}`, 14, yPos);

  // Add current month balances
  doc.setFontSize(12);
  yPos += 10;
  doc.text('Monat Salden in (h):', 14, yPos);
  textSize = doc.getTextDimensions('Monat Salden in (h):');
  doc.line(14, yPos + 1, 14 + textSize.w, yPos + 1);

  doc.setFontSize(10);
  yPos += 5;
  doc.text(`Arbeitszeit: ${TimeUtils.negativeMinutesToTime(currentWorkingTimeBalance)}`, 14, yPos);
  yPos += 5;
  doc.text(`Verfügungszeit: ${TimeUtils.negativeMinutesToTime(currentAvailableTimeBalance)}`, 14, yPos);

  // Legende
  const xPos = doc.internal.pageSize.getWidth() * 0.75;
  let yPosL = 30;
  doc.setFontSize(12);
  doc.text('Legende:', xPos, yPosL);
  textSize = doc.getTextDimensions('Legende:');
  doc.line(xPos, yPosL + 1, xPos + textSize.w, yPosL + 1);

  doc.setFontSize(10);
  yPosL += 5;
  doc.text('- Kalenderwoche (KW)', xPos, yPosL);
  yPosL += 5;
  doc.text('- Wochentag (WT)', xPos, yPosL);
  yPosL += 5;
  doc.text('- Arbeitszeit (AZ)', xPos, yPosL);
  yPosL += 5;
  doc.text('- Verfügungszeit (VZ)', xPos, yPosL);

  // Define starting position for the tables after the title
  let startY = 80; // Increase the y value here

  const weeks = new Set(data.map((item) => item.week));

  weeks.forEach((week) => {
    const weekData = data.filter((item) => item.week == week);

    const body: CellDef[][] = [];

    weekData.forEach((item) => {
      const row: CellDef[] = [
        item.day as CellDef,
        item.week.toString() as CellDef,
        item.weekDay as CellDef,
        (item.workingTime / 60).toString() as CellDef,
        (item.workingTimeBalance / 60).toString() as CellDef,
        item.availableTime.toString() as CellDef,
        item.availableTimeBalance.toString() as CellDef,
        item.notes as CellDef,
      ];
      body.push(row);
    });

    autoTable(doc, {
      head: header,
      body: body,
      startY: startY,
    });

    // Update startY for the next table to avoid overlap
    const finalY = (doc as any).lastAutoTable.finalY;
    startY = finalY + 10;
  });

  doc.save(fileName);
};

export default { exportPdf };
